import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import { CtaButton } from "components/CtaButton";
import { Links } from "libs/constants";
import { ReactComponent as PCIcon } from "icons/pc.svg";
import { ReactComponent as AndroidIcon } from "icons/android.svg";

import { useModalPopup } from "hooks/useModalPopup";
import usePlatform from "hooks/usePlatform";

export const Reserve = () => {
	const { t } = useI18next();
	const { openDMMPopup } = useModalPopup();
	const { isMobilePlatform } = usePlatform();

	return (
		<div className="flex flex-col items-center gap-4">
			<div>
				{isMobilePlatform ? (
					<CtaButton href={Links.Download}>{t("button.download")}</CtaButton>
				) : (
					<CtaButton onClick={openDMMPopup}>{t("button.download")}</CtaButton>
				)}
			</div>
			<div className="flex justify-center items-center">
				<p className="pr-1 text-sm font-bold drop-shadow-[0_1px_4px_#6A20CA]">対応デバイス</p>
				<PCIcon width={27} height={26} />
				<AndroidIcon width={27} height={26} />
			</div>
		</div>
	);
};
